
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/facet/[destinationSlug]/[facetSlug]",
      function () {
        return require("private-next-pages/facet/[destinationSlug]/[facetSlug]/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/facet/[destinationSlug]/[facetSlug]"])
      });
    }
  